import type { RxJsonSchema } from 'rxdb';
import type { InspectionList } from './inspectionList.types';

export const inspectionListSchema: RxJsonSchema<InspectionList> = {
  type: 'object',
  version: 1,
  description: 'describes inspection lists',
  primaryKey: 'inspectionId',
  properties: {
    inspectionId: { type: 'string', maxLength: 36 },
    assetId: { type: ['number', 'null'] },
    assetName: { type: ['string', 'null'] },
    assetDescription: { type: ['string', 'null'] },
    assetInspectionType: { type: ['string', 'null'] },
    assetInspectionStatusId: { type: ['number', 'null'] },
    assetInspectionStatus: { type: ['string', 'null'] },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    workPackageId: { type: ['number', 'null'] },
    inspectorId: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    isLIstampingRequired: { type: ['boolean', 'null'] },
    isAdhoc: { type: ['boolean', 'null'] },
    inspectionAssignmentComment: { type: ['string', 'null'] },
    areaList: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          assetId: { type: ['string', 'null'] },
          id: { type: ['string', 'null'] },
          name: { type: ['string', 'null'] },
          type: { type: ['number', 'null'] },
          trafficSafety: { type: ['number', 'null'] },
          areaName: { type: ['string', 'null'] },
        },
      },
    },
    areaId: { type: ['number', 'null'] },
  },
};
